import { useState } from 'react'

import { Titles } from 'components/faqSection/menu/MenuData'
import { ListItem } from 'components/uikit/ListItem'
import { AnalyticsActionType } from 'types/analytics.type'

import { ANALYTICS_EVENTS, trackAnalytics } from '../../../utils/analytics'

interface MenuProps {
  setActiveItem: (item: string) => void
  setTitle: (item: string) => void
}

const Menu = ({ setActiveItem, setTitle }: MenuProps) => {
  const [activeItem, setActiveItemState] = useState<string>('general information')

  const handleItemClick = (title: string) => {
    setActiveItem(title)
    setTitle(title)
    setActiveItemState(title)

    let payload = null

    switch (title) {
      case 'general information':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_GENERAL_INFO
        break
      case 'categories':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_CATEGORIES
        break
      case 'submission process':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_SUBMISSION_PROCESS
        break
      case 'judging process':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_JUDGING_PROCESS
        break
      case 'awards & recognition':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_AWARDS_RECOGNITION
        break
      case 'technical issues & support':
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_TECH_ISSUES_SUPPORT
        break
      case "people's vote":
        payload = ANALYTICS_EVENTS.ACTION.NEED_TO_KNOW_PEOPLES_VOTE
        break
      default:
        break
    }

    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: payload ?? '',
    })
  }

  return (
    <div className="h-fit flex flex-col gap-3 rounded-[24px] p-6 [box-shadow:0_4px_12px_0_#3939391F]">
      {Titles.map(({ title }) => {
        return (
          <ListItem key={title} onClick={() => handleItemClick(title)} selectable checked={activeItem === title}>
            <span slot="label" className="text-14 leading-[22px] tracking-0 font-semibold uppercase text-wrap">
              {title}
            </span>
          </ListItem>
        )
      })}
    </div>
  )
}

export default Menu
